import type { PlayerSortPayload } from '@/services/quizzes';
import { Icon } from '@/components/atoms/Icon';
import styles from './QuizQuestion.module.scss';

interface SortQuestionProps {
  payload: PlayerSortPayload;
  value: string[];
  onChange: (orderedIds: string[]) => void;
  disabled?: boolean;
  reveal?: boolean;
}

// El alumno reordena con botones up/down. Más accesible y sin dependencias que un drag&drop completo.
export function SortQuestion({ payload, value, onChange, disabled, reveal }: SortQuestionProps) {
  const items = value.length === payload.items.length
    ? value.map((id) => payload.items.find((it) => it.id === id)).filter((it) => it != null)
    : payload.items;

  function move(index: number, dir: -1 | 1) {
    if (disabled) return;
    const next = items.map((i) => i.id);
    const target = index + dir;
    if (target < 0 || target >= next.length) return;
    const a = next[index];
    const b = next[target];
    if (a === undefined || b === undefined) return;
    next[index] = b;
    next[target] = a;
    onChange(next);
  }

  return (
    <ul className={styles.sortList}>
      {items.map((it, idx) => {
        const correctIdx = reveal && it.correct_position !== undefined ? it.correct_position : null;
        return (
          <li key={it.id} className={styles.sortItem}>
            <span className={styles.sortPosition}>{idx + 1}</span>
            <span className={styles.sortText}>{it.text}</span>
            {correctIdx !== null && (
              <span className={styles.sortPosition} title="Posición correcta">{correctIdx}</span>
            )}
            {!reveal && (
              <span className={styles.sortControls}>
                <button
                  type="button"
                  className={styles.iconButton}
                  onClick={() => move(idx, -1)}
                  disabled={disabled || idx === 0}
                  aria-label="Subir"
                >
                  <Icon name="chevron-up" size={16} />
                </button>
                <button
                  type="button"
                  className={styles.iconButton}
                  onClick={() => move(idx, 1)}
                  disabled={disabled || idx === items.length - 1}
                  aria-label="Bajar"
                >
                  <Icon name="chevron-down" size={16} />
                </button>
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
